import { Component, Inject, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import Vuetify from "vuetify";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  COLLECTIONS_NAME,
  FORM_CONSTANTS,
  FORM_MESSAGES,
  FORM_VALIDATORS
} from "@/shared/constants/FormConstants";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { Utils } from "@/shared/utils/utils";
import {
  EMIT_ACTION_PLAN_TEMPLATE_EVENTS,
  LABELS_ADD_ACTIONPLAN_FORM,
  TEMPLATEPDF_CONSTANTS,
  TEMPLATEPDF_MESSAGES,
  TEMPLATE_PDF_ACCESS
} from "../../constants/TemplatePdfConstants";
import { Http } from "@status/codes";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import { TemplatePdf } from "../../Models/templatePdf";
import "firebase/storage";
import { TemplatePdfService } from "../../services/templatePdfService";
import MultimediaManager from "@/shared/components/MultimediaManager/MultimediaManager.vue";
import { MultimediaSelected } from "@/shared/components/MultimediaManager/models/MultimediaSelected.model";
import { MULTIMEDIA_CLEANED } from "@/shared/components/MultimediaManager/constants/MultimediaManagerConstants";
import { AxiosError } from "axios";
import { GENERAL_CONSTANTS } from "@/shared/constants/GeneralConstants";

Vue.use(Vuetify);
@Component({
  name: "SaveTemplatePdf",
  components: {
    ModalTemplate,
    MultimediaManager
  }
})
export default class SaveTemplatePdf extends Vue {
  @Inject() templatePdfService!: TemplatePdfService;
  @Prop() isModal!: boolean;
  @Prop() idTemplateProp!: string;
  @Prop() templateToEdit!: TemplatePdf;

  iconBtnClass = STYLE_CLASSES.ICON_BTN;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  PAGE_START = FORM_CONSTANTS.BUTTON.PAGE_START;
  CANCEL = FORM_CONSTANTS.BUTTON.CANCEL;

  modalTitle = FORM_MESSAGES.SAVE_MODAL.TITLE;
  modalText = FORM_MESSAGES.SAVE_MODAL.MESSAGE;
  dialog = false;
  ADD_LABEL_TITLE = LABELS_ADD_ACTIONPLAN_FORM;

  headerFile: File = {} as File;
  footerFile: File = {} as File;

  requiredField = [
    FORM_VALIDATORS.REQUIRED_FIELD,
    FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR
  ];

  // form data
  formData: TemplatePdf = {
    name: "",
    businessDetails: [
      { logo: false },
      { nit: false },
      { phone: false },
      { companyName: false },
      { address: false }
    ],
    multimediaHeader: { ...MULTIMEDIA_CLEANED },
    multimediaFooter: { ...MULTIMEDIA_CLEANED },
    state: true
  };

  // validation form
  validTemplate = false;
  // options
  SAVE_BTN = FORM_CONSTANTS.BUTTON.SAVE;

  PAGE_TITLE = "Nueva plantilla";

  idTemplateEdit = "";
  isEditTemplate = false;

  dialogOptions = false;
  indexEditing = -1;
  changeType = false;
  errorsName: string[] = [];
  isValidName = false;

  // methods

  // method add template
  async save() {
    if (this.isEditTemplate) {
      this.modalTitle = FORM_MESSAGES.SAVE_MODAL.TITLE;
      this.modalText = FORM_MESSAGES.SAVE_MODAL.MESSAGE;
      this.dialog = true;
    } else {
      const DATAFORM = this.formData;
      if (DATAFORM.name.trim() == "") {
        Snackbar.popError("El nombre es requerido");
        return;
      }

      const validateOptions = DATAFORM.businessDetails.filter(
        option => Object.values(option)[0]
      );
      if (validateOptions.length == 0) {
        Snackbar.popError(
          "Selecciona por lo menos un detalle para mostrar de la empresa"
        );
        return;
      }

      this.modalTitle = FORM_MESSAGES.SAVE_MODAL.TITLE;
      this.modalText = FORM_MESSAGES.SAVE_MODAL.MESSAGE;
      this.dialog = true;
    }
  }

  @Watch("idTemplateProp")
  async changeTemplate() {
    if (this.idTemplateProp) {
      this.getTemplatePdfById(this.templateToEdit, this.idTemplateProp);
      this.PAGE_TITLE = "Editar plantilla";
      this.isEditTemplate = true;
    } else {
      this.openDialogOptions();
      this.isEditTemplate = false;
    }
  }
  @Watch("changeType")
  changeTemplateType() {
    if (this.changeType) {
      this.$emit(EMIT_ACTION_PLAN_TEMPLATE_EVENTS.CHANGE_TEMPLATE_TYPE);
      this.changeType = false;
    }
  }
  openDialogOptions() {
    this.dialogOptions = true;
    this.indexEditing = -1;
  }

  goToStart(id: string) {
    Utils.scrollToElement(id, this);
  }

  cancel(): void {
    this.$emit(TEMPLATEPDF_CONSTANTS.REFERENCES_TEXTS.CLOSE_MODAL);
  }

  getTemplatePdfById(template: TemplatePdf, id: string) {
    this.idTemplateEdit = id;
    this.formData.name = template.name;
    this.formData.businessDetails = template.businessDetails;
    this.formData.multimediaHeader = template.multimediaHeader;
    this.formData.multimediaFooter = template.multimediaFooter;

    this.isValidName = this.formData.name != "" ? true : false;
  }

  // controlar el estado del modal
  async handleModalAccept() {
    this.dialog = false;
    if (this.modalTitle === FORM_MESSAGES.SAVE_MODAL.TITLE) {
      await this.doIfOk();
    }
    if (this.modalTitle === FORM_MESSAGES.CANCEL_MODAL.TITLE) {
      if (this.isModal) {
        this.$emit(TEMPLATEPDF_CONSTANTS.REFERENCES_TEXTS.CLOSE_MODAL);
      } else {
        this.$emit(TEMPLATEPDF_CONSTANTS.REFERENCES_TEXTS.SAVE_TEMPLATE);
      }
    }
  }

  handleModalCancel() {
    this.dialog = false;
  }

  // metodo de actualizar o guardar
  async doIfOk() {
    const formdataClone = { ...this.formData };
    formdataClone.multimediaFooter = {
      _key: this.formData.multimediaFooter!._key
    };
    formdataClone.multimediaHeader = {
      _key: this.formData.multimediaHeader!._key
    };

    try {
      if (this.isEditTemplate) {
        const responseData = await this.templatePdfService.updateTemplate(
          formdataClone,
          this.idTemplateEdit
        );
        if (responseData.code == Http.Ok) {
          Snackbar.popSuccess(TEMPLATEPDF_MESSAGES.EDIT_SUCCESSFULLY);
          this.formData = {
            name: "",
            businessDetails: [
              { logo: false },
              { nit: false },
              { phone: false },
              { companyName: false },
              { address: false }
            ],
            multimediaHeader: { ...MULTIMEDIA_CLEANED },
            multimediaFooter: { ...MULTIMEDIA_CLEANED },
            state: true
          };

          if (this.isModal) {
            this.$emit(TEMPLATEPDF_CONSTANTS.REFERENCES_TEXTS.CLOSE_MODAL);
          } else {
            this.$emit(TEMPLATEPDF_CONSTANTS.REFERENCES_TEXTS.SAVE_TEMPLATE);
          }
        } else {
          Snackbar.popError(responseData.message);
        }
      } else {
        const responseData = await this.templatePdfService.saveTemplate(
          formdataClone
        );
        if (responseData.code == Http.Ok) {
          Snackbar.popSuccess(TEMPLATEPDF_MESSAGES.SAVED_SUCCESSFULLY);

          if (this.isModal) {
            this.$emit(TEMPLATEPDF_CONSTANTS.REFERENCES_TEXTS.CLOSE_MODAL);
          } else {
            this.$emit(TEMPLATEPDF_CONSTANTS.REFERENCES_TEXTS.SAVE_TEMPLATE);
          }
        } else {
          Snackbar.popError(responseData.message);
        }
      }
    } catch (error) {
      const METHOD = Utils.getMethodHTTP(
        error as AxiosError
      ) as keyof typeof TEMPLATE_PDF_ACCESS;
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${TEMPLATE_PDF_ACCESS[METHOD]}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  async mounted() {
    this.changeTemplate();
  }

  getFileHeader(fileSelected: MultimediaSelected) {
    this.formData.multimediaHeader = fileSelected;
  }

  getFileFooter(fileSelected: MultimediaSelected) {
    this.formData.multimediaFooter = fileSelected;
  }

  async validateUniqueName() {
    this.errorsName = await Utils.checkUniqueName(
      COLLECTIONS_NAME.TEMPLATES_PDF,
      this.formData.name
    );
    this.isValidName = !(this.errorsName.length > 0);
  }
}
